/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-25 19:02:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-07 15:09:16
 * @Description: file content
 */
import Vue from "vue/dist/vue.js";
import App from "./app.vue";
import router from "./router";
import pluginsAct from "@/plugins/act-plugin";
import BaseTurntableMain from "./BaseTurntableMain.vue";

import VConsole from "vconsole";
if (process.env.VUE_APP_SERVE_ENV !== "prod" && !(location.host.indexOf("localhost") > -1)) {
  new VConsole();
}
// if (location.href.indexOf('actCode=ACT1720261395348791296')>-1) {
//   new VConsole();
// }

import yqAnalytics from "yq-analytics";
if(process.env.VUE_APP_SERVE_ENV !== "prod"){
  yqAnalytics.init({
    env: "test",
    appId: "9ed2cbb1a929b5b443b00f5fd06c6631",
  })
}else{
  yqAnalytics.init({
    appId: "96ca2b41fc646c1dcec57dc96c3eaf93",
  })
}
Vue.use(pluginsAct);
Vue.component("BaseTurntableMain", BaseTurntableMain);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
